module.exports = __webpack_public_path__ + "img/floppy-disk-circle-xmark.5aa8109a.svg";